import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import Planning from "./Planning";
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";

function AnalystApporoval() {
  const [currentTab, setCurrentTab] = useState("1");
  const [reset, setReset] = useState(false);
  const [planData, setPlanData] = useState([]);
  const [assessment, setAssessment] = useState();
  const [workProgramData, setWorkProgramData] = useState();
  const [loading, setLoading] = useState(false);
  const [changeRequestsRiskData, setChangeRequestsRiskData] = useState();
  const [allClassifications, setAllClassifications] = useState();
  const [allVendorList, setAllVendorList] = useState();
  const [dataLoader, setDataLoader] = useState(false)
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getAllTPRequests } = useHttp();
  const { sendRequest: getAnalystWorkPrograms } = useHttp();
  const { sendRequest: getAssessmentList } = useHttp();
  const { sendRequest: deleteTPRequest } = useHttp();
  const { sendRequest: deleteAssessmentPlan } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: getAllClassifications } = useHttp();
  const { sendRequest: getChangeRequestsRiskData } = useHttp();
  const { sendRequest: updateRiskRequestById } = useHttp();
  const { sendRequest: deleteRiskRequestByID } = useHttp();

  const getTPRequest = async () => {
    getAllTPRequests(APIService.getAllTPRequests(), (res) => {
      if (res.CODE) {
        setPlanData(res.MSG[0]);
      }
    })
  };
  const getAllVendorListData = async () => {
    getAllVendorList(APIService.getAllVendorList(), (data) => {
      setAllVendorList(data.MSG)
    })
  };
  const getAllClassificationsData = async () => {
    getAllClassifications(APIService.getAllClassifications(), (data) => {
      setAllClassifications(data.MSG);
    })
  };
  const getChangeRequestsRisk = async () => {
    getChangeRequestsRiskData(APIService.getChangeRequestsRiskData(), (res) => {
      if (res.CODE) {
        res.MSG.forEach(function (a) {
          a.expiray_date = a.expiray_date.substring(0, 10);
          a.date_issued = a.date_issued.substring(0, 10);
        });
        setChangeRequestsRiskData(res.MSG);
      }
    })
  };

  const getWorkPrograms = async () => {
    getAnalystWorkPrograms(APIService.getAnalystWorkPrograms(), (res) => {
      if (res.CODE) {
        setWorkProgramData(res.MSG[0]);
      }
    })
  };

  const getAssessments = async () => {
    getAssessmentList(APIService.getAssessmentList(), (res) => {
      if (res.CODE) {
        setAssessment(res.MSG[0]);
      }
    })
  };

  const handleDeleteTPRequest = async (ID1, ID2, setSearch) => {
    let data = { vendorAssessmentRequestID: ID1, userId: ID2.toString(),email:sessionStorage.getItem("email")
  };
    setLoading(true);
    try {
      deleteTPRequest(APIService.deleteTPRequest(data), (result) => {
        if (result.CODE) {
          setLoading(false);
          displayToastMessage(result.MSG, "success");
          getTPRequest();
          setSearch("");
        } else {
          setLoading(false);
          getTPRequest();
          displayToastMessage("Something went wrong!", "error");
          setSearch("");
        }
      })
    } catch (error) {
      console.log("Error",error)
      setLoading(false);
      setSearch("");
      getTPRequest();
      displayToastMessage("Something went wrong!", "error");
    }
  };

  const handleDeleteWorkProgram = async (ID1, ID2) => {
    let data = { assessmentId: ID1, userId: ID2.toString() };
    setLoading(true);
    try {
      deleteAssessmentPlan(APIService.deleteAssessmentPlan(data), (result) => {
        if (result.CODE) {
          setLoading(false);
          displayToastMessage(result.MSG, "success");
          getAssessments();
        } else {
          setLoading(false);
          getTPRequest();
          displayToastMessage("Something went wrong!", "error");
        }
      })
    } catch (error) {
      console.log("Error",error)
      setLoading(false);
      getTPRequest();
      displayToastMessage("Something went wrong!", "error");
    }
  };

  const handleDelete = async (vendorId) => {
    setLoading(true);
    try {
      deleteRiskRequestByID(APIService.deleteRiskRequestByID(vendorId), (result) => {
        if (result.CODE) {
          setLoading(false);
          displayToastMessage(result.MSG, "success");
          getChangeRequestsRisk();
        } else {
          setLoading(false);
          displayToastMessage("Something went wrong!", "error");
        }
      })
    } catch (error) {
      console.log("Error",error)
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
    }
  };


  useEffect(() => {
    setDataLoader(true)
    getTPRequest();
    getAssessments();
    getWorkPrograms();
    getChangeRequestsRisk();
    getAllVendorListData();
    getAllClassificationsData();
    setDataLoader(false)
  }, []);

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setReset(!reset);
  };
  const updateManageRisk = async (data) => {
    setLoading(true);
    try {
      updateRiskRequestById(APIService.updateRiskRequestById(data), (result) => {
        if (result.CODE) {
          displayToastMessage(result.MSG, "success");
          setLoading(false);
          let notifData = {
            paramuserid: Number(sessionStorage.getItem("userId")),
            paramreqid: data.risk_id,
            paramcontent: "Update Request Type",
            paramnextroleid: 2,
            paramcreatedby: Number(sessionStorage.getItem("roleId")),
            parammsgtype: result.MSG,
          };
          handleNotificationSubmitAPI(APIService.handleNotificationSubmit(notifData),()=>{})
          getChangeRequestsRisk();
        } else {
          setLoading(false);
          displayToastMessage("Something went wrong, Please try again!", "error");
        }
      })
    } catch (error) {
      console.log("Error",error)
      let Msg = "Action failed. Please try again!";
      displayToastMessage(Msg, "error");
    }
  };
  if (loading) {
    return (
      <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
    );
  }

  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="Planning Requests">
          <Planning
            reset={reset}
            Plan={planData}
            handleDelete={handleDeleteTPRequest}
            refreshTPRequest={getTPRequest}
          />
        </Tab>
        {/* <Tab value="2" label="Work Program Creation">
          <WorkProgramCreation
            reset={reset}
            AssessmentData={assessment}
            handleDelete={handleDeleteWorkProgram}
          />
        </Tab>
        <Tab value="3" label=" View Work Program">
          <UpdateWorkprogram reset={reset} AllWorkProgram={workProgramData} />
        </Tab>
        <Tab value="4" label=" Change Requests">
          <ChangeRequests
            reset={reset}
            changeRequestsRiskData={changeRequestsRiskData}
            allVendorList={allVendorList}
            allClassifications={allClassifications}
            updateManageRisk={updateManageRisk}
            handleDelete={handleDelete}
          />
        </Tab> */}
        {/* <Tab value="4" label="View Closure Requests">
          <ViewClosureRequests reset={reset} />
        </Tab> */}
      </Tabs>
    </div>
  );
}
export default AnalystApporoval;
